
import React, { useEffect, useState } from 'react';
import Loadar from '../../common/loader/Loader';
import { Table, Pagination, Button, Space, Dropdown, Menu, message , Modal, Input } from 'antd';
import moment from 'moment/moment';
import { Link } from 'react-router-dom';
import { Card } from 'react-bootstrap';
import { DownloadOutlined, EditOutlined, EllipsisOutlined ,RollbackOutlined } from '@ant-design/icons';
import { getCourierUserList } from '../../api/login/Login';
import CustomInputField from '../../common/CustomInputField';

const CourierOnboardingVerify = () => {

      const getCurrentDate = () => {
        const today = new Date();
        return today.toISOString().substr(0, 10);
    };
    const [pageNumber , setPagenumber] = useState(1)
    const [data , setData ] = useState()
    const [resetKey , setResetkey] = useState(false)
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState({
        name: '',
        mobile: '',
        email: '',
        end_date :'',
        start_date : ''
        // refer_id: '',
        // kycStatus: '',
    });

    const handleChange = (e) => {
        const { id, value } = e.target;
        setFormData((prev) => ({ ...prev, [id]: value }));
    };

    const handlePhoneChange = (e) => {
        const { value } = e.target;
        // Allow up to 10 characters only (no validation, just max length)
        if (value.length <= 10) {
            setFormData((prev) => ({ ...prev, mobile: value }));
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        // console.log('Submitting filter:', formData);
        setResetkey((pre)=>!pre)
        setPagenumber(1)
       
    };

    const resetForm = () => {
        setFormData({
            name: '',
            mobile: '',
            email: '',
             end_date :'',
        start_date : ''
            // refer_id: '',
            // kycStatus: '',
        });
        setResetkey((pre)=>!pre)
        setPagenumber(1)
    
    };

    useEffect(()=>{
        getUser()
    },[pageNumber , resetKey])
  

    const getUser = async()=>{
        setLoading(true)
        const body = {
            ...formData,
            page:pageNumber,
            count:10
        }
        try {
            let res = await getCourierUserList(body)
         
            if(res?.error === false)
            {
                setData(res?.data)
            } 
            else{
              setData([])
            }
        } catch (error) {
            
        } finally {
            setLoading(false)
        }
    
    }

    const onChangeVal = (e) => {
       
        setPagenumber(e)
    };

      const columns = [
        {
          title: 'Serial No.',
          key: 'serial',
          render: (text, record, index) => {
            // Calculate the serial number based on currentPage and the index in the current page
            // const serialNo = index + 1 + currentPage * pageSize; // Assuming pageSize is the number of rows per page
            const serialNo = (index + 1) + ((pageNumber-1) * 10) 
            return <span>{serialNo}</span>;
          },
        },
        {
          title: 'Name',
          key: 'name',
          render: (text, record) => (
            <div>
              <div className="fw-bold">{record.name || '-'}</div>
              <small className="text-muted">{record.member_type || '-'}</small>
            </div>
          ),
        },
        {
          title: 'Sponsor Number',
          dataIndex: 'sponsor',
          key: 'sponsor_id',
          render: (text , record) => record?.sponsor?.mobile || '-',
        },
        {
          title: 'Contact Info',
          key: 'contact',
          render: (text, record) => (
            <div>
              <div>{record.mobile || '-'}</div>
              <small className="text-muted">{record.email || '-'}</small>
            </div>
          ),
        },
      
        {
          title: 'Joining Date/Time',
          key: 'createdAt',
          render: (text, record) => (
            <div>
              <div>{record.createdAt ? moment(record.createdAt).format('DD/MM/YYYY') : '-'}</div>
              <small className="text-muted">
                {record.createdAt ? moment(record.createdAt).format('HH:mm:ss') : '-'}
              </small>
            </div>
          ),
        },
        
     
        {
          title: 'Action',
          key: 'action',
          render: (text, record) => (
            <Space size="small" className="d-flex">
            
            
              <Link 
                to={`/admin/Courier-onboarding/Users/${record._id}`} 
                className="btn btn-primary btn-sm"
              >
                <EditOutlined />
              </Link>
            </Space>
          ),
        },
      
      ];


      console.log(data , "data")
  return (
    <>
    {loading && <Loadar/>}
     <div className="row m-4">
            <div className="col-xl-12" style={{ padding: 0 }}>
                <div className="card">
                    <div className="card-body p-0">
                        <div className="table-responsive active-projects style-1">
                            <div className="tbl-caption tbl-caption-2">
                                <h4 className="heading mb-0">
                                    <b>Filter &nbsp;{'Courier List'}</b>
                                </h4>
                            </div>

                            <form
                               
                                className="row cusforms"
                                style={{ padding: 20 }}
                                onSubmit={handleSubmit}
                            >

                              
                              
                                                     <div className="form-group col-4">
                                    <CustomInputField
                                        type="date"
                                        className="form-control"
                                        id="start_date"
                                        placeholder="To"
                                        value={formData.start_date}
                                        onChange={handleChange}
                                        max={getCurrentDate()}
                                    />
                                </div>
                                 <div className="form-group col-4">
                                    <CustomInputField
                                        type="date"
                                        className="form-control"
                                        id="end_date"
                                        placeholder="From"
                                        value={formData.end_date}
                                        onChange={handleChange}
                                        max={getCurrentDate()}
                                    />
                                </div>
                                <div className="form-group col-4">
                                    <CustomInputField
                                        type="text"
                                        className="form-control"
                                        id="name"
                                        placeholder="Enter name"
                                        value={formData.name}
                                        onChange={handleChange}
                                    />
                                </div>

                                <div className="form-group col-4 mt-4">
                                    <CustomInputField
                                        type="number"
                                        className="form-control"
                                        id="mobile"
                                        placeholder="Enter mobile number"
                                        value={formData.mobile}
                                        onChange={handlePhoneChange}
                                    />
                                </div>

                                <div className="form-group col-4 mt-4">
                                    <CustomInputField
                                        type="email"
                                        className="form-control"
                                        id="email"
                                        placeholder="Enter email"
                                        value={formData.email}
                                        onChange={handleChange}
                                    />
                                </div>

                                {/* <div className="form-group col-4">
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="refer_id"
                                        placeholder={`Enter ref id`}
                                        value={formData.refer_id}
                                        onChange={handleChange}
                                    />
                                </div> */}

                                {/* <div className="form-group col-4">
                                    <select
                                        className="form-control"
                                        id="kycStatus"
                                        value={formData.kycStatus}
                                        onChange={handleChange}
                                    >
                                        <option value="">Select KYC Status</option>
                                        <option value="verified">Verified</option>
                                        <option value="unverified">Unverified</option>
                                    </select>
                                </div> */}

                            

                                <div className="form-group col-12" style={{ margin: "20px 0" }}>
                                    <button type="submit" className="btn btn-primary">
                                        SEARCH
                                    </button>
                                    <button type="button" className="btn btn-secondary" onClick={resetForm}>
                                        RESET
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div className="m-4">
      <Card>
        <Card.Header className=" active-projects style-1">
          
          <div className="w-100 tbl-caption">
                  <h4 className="heading mb-0"><b>{'Courier'} List</b></h4>
                  <div>
                   
                    {/* <CSVLink 
                data={csvData} 
                filename={`${params?.name || 'distributor'}_list.csv`}
                className="btn btn-primary border border-white"
                style={{backgroundColor:'bs(--nav)'}}
              >
                <DownloadOutlined /> Download Excel
              </CSVLink> */}
                    
                  </div>
                </div>
        </Card.Header>
        <Card.Body className="p-0">
         
          <Table
            columns={columns}
            dataSource={data?.merchantData || []}
            rowKey={(record) => record?._id || Math.random()}
            loading={loading}
            pagination={false}
            className="custom-table"
            scroll={{ x: true }}
          />
          <div className="p-3 d-flex justify-content-between align-items-center">
            <div>
              Total {data?.totalCount || 0} entries
            </div>
            <Pagination
              total={data?.totalCount || 0}
              onChange={onChangeVal}
              showSizeChanger={false}
              current={pageNumber}
              showQuickJumper
              
            />
          </div>
        </Card.Body>
      </Card>

    
 

 
    </div>   
    
    </>
  )
}

export default CourierOnboardingVerify